import { getApiErrorMessage, isApiError } from "~/utils/apiClient";

/** What a lineage panel says when an artifact's recipe can't be loaded.
 *
 *  A 400 carries the reason the lineage does not describe something runnable,
 *  which says more than a generic failure.
 */
export const recipeErrorMessage = (error: unknown): string =>
  isApiError(error) && error.status === 400
    ? getApiErrorMessage(error)
    : "Couldn't load this artifact's lineage.";
